import classNames from 'classnames';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import { useMatch, useResolvedPath } from 'react-router';

import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';

import config from '../../config';
import { getAppContext } from '../../utils/helpers';

import styles from './Header.module.scss';

export interface HeaderProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header = ({ open, setOpen }: HeaderProps) => {
    const { sportLabel } = getAppContext();
    const resolvePath = useResolvedPath('');
    const match = useMatch(`${resolvePath.pathname}/:sect/*`);
    const currentSection = match?.params.sect
        ? config.references.sideBarSections[
              match?.params?.sect as keyof typeof config.references.sideBarSections
          ]
        : 'Главная' || 'Главная';

    return (
        <AppBar
            position="fixed"
            className={classNames(styles.appBar, {
                [styles.appBarShift]: open
            })}
            elevation={1}
        >
            <Toolbar>
                <Typography className={styles.title} variant="h6" noWrap>
                    {currentSection}
                    <span className={styles.sportBadge}>{sportLabel}</span>
                </Typography>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={() => setOpen((prevState) => !prevState)}
                    edge="start"
                    size="large"
                    className={classNames(styles.menuButton)}
                >
                    <MenuIcon fontSize="inherit" />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
